import React from "react";
import Navbar from "./Components/Navbar";
import Hero from "./Components/Hero";
import About from "./Components/about";
import Projects from "./Components/Projects";
import Skills from "./Components/Skills";
import Contact from "./Components/Contact";
import Footer from "./Components/footer";
import Resume from "./Components/resume";
import './App.css';

const App = () => {
  return (
    <div className="relative bg-black text-white scrollbar">
      {/* Fixed Navbar */}
      <Navbar className="fixed top-0 left-0 right-0 z-50" />

      {/* Container for parallax effect */}
      <div className="relative">
        {/* Hero Section - Sticky */}
        <div className="sticky top-0 h-screen z-10">
          <Hero />
        </div>

        {/* Scrolling content that overlays Hero */}
        <div className="relative z-20 bg-black min-h-screen">
          {/* About section with slight transform on parent for parallax */}
          <div className="transform-gpu translate-y-32 bg-black">
            <About />
          </div>

          {/* Rest of the sections */}
          <div className="bg-black">
            <Projects />
            <Skills />
            <Resume />
            <Contact />
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;